import { retry } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { API_RETRY_COUNT } from '@shared/constants';

import { CacheService } from './cache.service';
import { ConfigService } from './config.service';

export const dataURLtoFile2 = (b64Data, contentType = '', sliceSize = 512) => {
	const byteCharacters = atob(b64Data);
	const byteArrays = [];

	for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
		const slice = byteCharacters.slice(offset, offset + sliceSize);

		const byteNumbers = new Array(slice.length);
		for (let i = 0; i < slice.length; i++) {
			byteNumbers[i] = slice.charCodeAt(i);
		}

		const byteArray = new Uint8Array(byteNumbers);
		byteArrays.push(byteArray);
	}

	const blob = new Blob(byteArrays, { type: contentType });
	return blob;
};

export function dataURLtoFile(dataurl, filename) {
	var arr = dataurl.split(','),
		mime = arr[0].match(/:(.*?);/)[1],
		bstr = atob(arr[1]),
		n = bstr.length,
		u8arr = new Uint8Array(n);

	while (n--) {
		u8arr[n] = bstr.charCodeAt(n);
	}

	return new File([u8arr], filename, { type: mime });
}
@Injectable({ providedIn: 'root' })
export class FileService {
	public httpRequestHeaders = {
		'x-env-name': this.env.get<string>('env'),
	};
	public uploadEndpoint: string = this.env.get('storageEndPoint');

	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - constructor
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private readonly platform: Platform,
		private readonly http: HttpClient,
		private readonly env: ConfigService,
		private readonly cache: CacheService
	) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - uploadFile
	 **-------------------------------------------------------------------------------------
	 */
	public uploadFile({ rawFile, fileName, path }) {
		const formData = new FormData();
		var file = dataURLtoFile(rawFile.dataUrl, `${fileName}.${rawFile.format}`);
		formData.set('object', file, fileName);
		formData.set('originating_identifier', path + `${fileName}.${rawFile.format}`);
		return this.http.post(this.uploadEndpoint + '/file', formData, {
			headers: this.httpRequestHeaders,
		});
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - getMetaData
	 **-------------------------------------------------------------------------------------
	 */
	public async getMetaData() {
		return {
			ip_address: `${await this.cache.get('ipAddress', 'Not Available')}`,
			latitude: `${await this.cache.get('latitude', 'Not Available')}`,
			longitude: `${await this.cache.get('longitude', 'Not Available')}`,
		};
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME - uploadFile2
	 **-------------------------------------------------------------------------------------
	 */
	public uploadFile2({ rawFile, fileName, path, mime, isSignature = false, extras = {} }) {
		const formData = new FormData();
		let file;
		if (isSignature) rawFile.dataUrl = rawFile.dataUrl.split(',')[1];
		if (this.platform.is('cordova') || isSignature) file = dataURLtoFile2(rawFile.dataUrl, mime);
		else file = dataURLtoFile(rawFile.dataUrl, `${fileName}.${rawFile.format}`);
		formData.set('object', file, fileName.split('.')[0]);
		formData.set('originating_identifier', path + `${fileName}`);
		formData.set('extras', JSON.stringify(extras));
		return this.http
			.post(this.uploadEndpoint + '/file', formData, {
				headers: this.httpRequestHeaders,
			})
			.pipe(retry({ count: API_RETRY_COUNT, delay: 2000 }));
	}
}
